// extracted by mini-css-extract-plugin
export default {"authForm":"auth_authForm__L7eZe","authField":"auth_authField__03IBB","codeField":"auth_codeField__dcdYm","authActions":"auth_authActions__YfUeJ","authLink":"auth_authLink__fn9-L"};